<template>
	<v-container grid-list-md>
		<v-card>
			<v-card-title primary-title>
				<v-btn
					@click="$inertia.visit($route('central.memberships.index'))"
					rounded
					color="primary"
					dark
					small
				>
					<v-icon left>mdi-arrow-left</v-icon> Back
				</v-btn>
				<v-spacer></v-spacer>
			</v-card-title>
			<v-divider></v-divider>
			<v-card-text>
				<v-layout row wrap>
					<v-flex xs12 md8>
						<v-layout row wrap>
							<v-flex xs2 md2>
								<v-list-item-title class="float-right mt-3"
									>Code:</v-list-item-title
								>
							</v-flex>
							<v-flex xs4 md4>
								<v-list-item-title
									class="mt-3 pl-5 font-weight-black"
									>{{ membership.code }}</v-list-item-title
								>
							</v-flex>
							<v-flex xs2 md2>
								<v-list-item-title class="float-right mt-3">{{
									$t("Name")
								}}</v-list-item-title>
							</v-flex>
							<v-flex xs4 md4>
								<v-list-item-title
									class="mt-3 pl-5 font-weight-black"
									>{{
										membership.membership_name
									}}</v-list-item-title
								>
							</v-flex>
							<v-flex xs2 md2>
								<v-list-item-title class="float-right mt-3"
									>{{ $t("Price") }}:</v-list-item-title
								>
							</v-flex>
							<v-flex xs4 md4>
								<v-list-item-title
									class="mt-3 pl-5 font-weight-black"
									>{{
										membership.price | currency
									}}</v-list-item-title
								>
							</v-flex>
							<v-flex xs2 md2>
								<v-list-item-title class="float-right mt-3"
									>{{
										$t("label.active_subscribers_limit")
									}}:</v-list-item-title
								>
							</v-flex>
							<v-flex xs4 md4>
								<v-list-item-title
									class="mt-3 pl-5 font-weight-black"
									>{{
										membership.active_subscribers_limit
									}}</v-list-item-title
								>
							</v-flex>
						</v-layout>
					</v-flex>
					<v-flex xs12 md4>
						<v-layout row wrap>
							<v-flex xs2 md12>
								<v-img
									:src="
										membership.image_url
											? membership.image_url
											: '/images/image_placeholder.jpg'
									"
								></v-img>
							</v-flex>
						</v-layout>
					</v-flex>
				</v-layout>
			</v-card-text>
		</v-card>
		<p>&nbsp;</p>
		<v-card>
			<v-card-title>
				<v-card-title primary-title>
					{{ $t("label.subscription_history") }}</v-card-title
				>
			</v-card-title>
			<v-divider></v-divider>
			<v-card-text>
				<v-list>
					<v-list-item-group color="primary">
						<v-list-item
							v-for="(customers, index) in customers"
							:key="index"
						>
							<v-list-item-icon
								>{{ $t("Customer") }} :
							</v-list-item-icon>
							<v-list-item-content>
								<v-list-item-title
									><strong>{{
										customers.name
									}}</strong></v-list-item-title
								>
							</v-list-item-content>
						</v-list-item>
					</v-list-item-group>
					<v-divider></v-divider>
					<v-list-item-group color="primary">
						<v-list-item
							v-for="(subscriptions, index) in subscriptions"
							:key="index"
						>
							<v-list-item-icon
								>{{ $t("label.created_at") }} :
							</v-list-item-icon>
							<v-list-item-content>
								<v-list-item-title
									><strong>{{
										subscriptions.created_at
									}}</strong></v-list-item-title
								>
							</v-list-item-content>
						</v-list-item>
					</v-list-item-group>
					<v-divider></v-divider>
					<v-list-item-group color="primary">
						<v-list-item
							v-for="(subscriptions, index) in subscriptions"
							:key="index"
						>
							<v-list-item-icon
								>{{ $t("label.end_at") }} :
							</v-list-item-icon>
							<v-list-item-content>
								<v-list-item-title
									><strong>{{
										subscriptions.ends_at
									}}</strong></v-list-item-title
								>
							</v-list-item-content>
						</v-list-item>
					</v-list-item-group>
					<v-divider></v-divider>
					<v-list-item-group color="primary">
						<v-list-item
							v-for="(subscriptions, index) in subscriptions"
							:key="index"
						>
							<v-list-item-icon
								>{{ $t("Amount") }} :
							</v-list-item-icon>
							<v-list-item-content>
								<v-list-item-title
									><strong>{{
										subscriptions.amount
									}}</strong></v-list-item-title
								>
							</v-list-item-content>
						</v-list-item>
					</v-list-item-group>
					<v-divider></v-divider>
					<v-list-item-group color="primary">
						<v-list-item
							v-for="(subscriptions, index) in subscriptions"
							:key="index"
						>
							<v-list-item-icon
								>{{ $t("Payment Method") }} :
							</v-list-item-icon>
							<v-list-item-content>
								<v-list-item-title
									><strong>{{
										subscriptions.payment_method_code
									}}</strong></v-list-item-title
								>
							</v-list-item-content>
						</v-list-item>
					</v-list-item-group>
					<v-divider></v-divider>
					<v-list-item-group color="primary">
						<v-list-item
							v-for="(subscriptions, index) in subscriptions"
							:key="index"
						>
							<v-list-item-icon
								>{{ $t("label.payment_status") }} :
							</v-list-item-icon>
							<v-list-item-content>
								<v-list-item-title
									><strong>{{
										subscriptions.payment_status
									}}</strong></v-list-item-title
								>
							</v-list-item-content>
						</v-list-item>
					</v-list-item-group>
					<v-divider></v-divider>
					<v-list-item-group color="primary">
						<v-list-item
							v-for="(subscriptions, index) in subscriptions"
							:key="index"
						>
							<v-list-item-icon
								>{{ $t("Description") }} :
							</v-list-item-icon>
							<v-list-item-content>
								<v-list-item-title
									><strong>{{
										subscriptions.description
									}}</strong></v-list-item-title
								>
							</v-list-item-content>
						</v-list-item>
					</v-list-item-group>
				</v-list>
			</v-card-text>
		</v-card>
	</v-container>
</template>

<script>
export default {
	props: ["membership", "customers", "subscriptions"],
	data() {
		return {
			types: [
				{
					value: "percentage",
					text: this.$t("label.percentage"),
				},
				{
					value: "fixed",
					text: this.$t("label.fixed"),
				},
			],
		};
	},
};
</script>